import { useTranslation } from 'react-i18next'

import { LastModifiedCell } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import { DomainAlerts } from 'features/inventory/domain'
import ActionsCell from './components/ActionsCell'
import { useProductSwitchColumns } from './hooks/useProductSwitchColumns'
import { UseColumns } from './types'

export const useColumns: UseColumns = (tableFilters, tableItemsCount) => {
  const { t } = useTranslation('features/domain')
  const productColumns = useProductSwitchColumns({ tableFilters, tableItemsCount })

  return [
    {
      accessorKey: 'name',
      header: t('list.header.domainName'),
      meta: { whiteSpacePre: true },
    },
    ...productColumns,
    {
      accessorKey: 'alerts',
      cell: ({
        row: {
          original: { alerts },
        },
      }) => <DomainAlerts alerts={alerts} />,
      header: t('list.header.alerts'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('list.header.lastModified'),
    },
    {
      cell: ({ row }) => <ActionsCell {...row.original} />,
      header: t('list.header.actions'),
      id: 'actions',
      meta: {
        centered: true,
        nonClickable: true,
      },
      size: COLUMN_SIZE.SM,
    },
  ]
}
